import { StoreDevtoolsModule } from '@ngrx/store-devtools'

export const ngRxDevToolsConfig = [
  StoreDevtoolsModule.instrument({
    maxAge: 40,
    name: 'MediacoachMobile'
  })
]
